import { YesOrNo, useWizard } from '@insify/funnel-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCommands } from '../../hooks/useCommands';
import { useContent } from '../../hooks/useContent';
import { useParamsQuery } from '../../hooks/useQueries';

export const PastInsurancePage = () => {
  const { pastInsurances } = useContent() || {};
  const { t } = useTranslation(['common']);
  const { showNextPage, showPreviousPage } = useWizard();
  const { data: { pastInsuranceIssues } = {} } = useParamsQuery();
  const { sendCommandWithOptimisticUpdate } = useCommands();
  const [triggerShowingNextPage, setTriggerShowingNextPage] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (answer: boolean) => {
    setIsSubmitting(true);
    await sendCommandWithOptimisticUpdate({
      command: {
        type: 'givePastInsuranceIssuesConsent',
        payload: { consent: answer },
      },
      params: {
        pastInsuranceIssues: answer,
      },
    });
    setTriggerShowingNextPage(true);
  };

  useEffect(() => {
    if (triggerShowingNextPage && pastInsuranceIssues !== undefined) {
      showNextPage();
      setTriggerShowingNextPage(false);
    }
  }, [triggerShowingNextPage, pastInsuranceIssues]);

  return (
    <YesOrNo
      isSubmitting={isSubmitting}
      content={pastInsurances}
      translations={{
        yes: t('common:yes'),
        no: t('common:no'),
        submit: t('common:continue'),
        back: t('common:back'),
      }}
      value={pastInsuranceIssues}
      eventHandlers={{
        onSubmit: submit,
        onBack: showPreviousPage,
      }}
    />
  );
};
